// UseAuthStatus.js
import axios from 'axios';
import { useState, useEffect } from 'react';

const UseAuthStatus = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [tokenExp, setTokenExp] = useState(null);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_ADDRESS}/auth/validate`,
          { withCredentials: true }
        );
        setIsAuthenticated(response.data.isAuthenticated);
        setUserEmail(response.data.userEmail);
        setUserRole(response.data.userRole);
        if (response.data.exp) {
          // decoded.exp is in seconds, so convert to milliseconds
          setTokenExp(response.data.exp * 1000);
        }
      } catch (error) {
        console.error('Session validation error:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateSession();
  }, []);

  return { isAuthenticated, userEmail, userRole, isLoading, tokenExp };
};

export default UseAuthStatus;